import { InjectionToken, FactoryProvider, APP_INITIALIZER } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

export let USER_DATA_INITIALIZER = new InjectionToken('User Data Initializer');

export const UserDataInitializerProvider: FactoryProvider = {
  provide: APP_INITIALIZER,
  useFactory: initializeUser,
  deps: [Router, AuthService],
  multi: true,
};

export function initializeUser(
    router: Router,
    authService: AuthService,
  ): () => Promise<void> {

    return () =>
      new Promise((resolve) => {
        authService.isSignedIn().then(result => {
          if (result) {
            resolve();
          } else {
            authService.getUserDetails().then(result => {
              resolve();
            });
          }
        });
      });
  }